import React, { FC, memo } from 'react';

import Featured from '../../../../components/withTimerDesign/featured';
import MainScreen from '../../../../components/withTimerDesign/mainScreen';
import SafetyAssurance from '../../../../../../UI/common/safetyAssurance';
import GetMyPlanBlock from '../../../../components/getMyPlanBlock';
import Reviews from '../../../../components/withTimerDesign/reviews';
import Description from '../../../../components/withTimerDesign/description';
import SpecialFeatures from '../../../../components/specialFeatures';
import Plan from '../../../../components/withTimerDesign/plan';
import { OneMinuteQuiz } from '../../../../components/oneMinuteQuiz';
import { appStore } from '@store';
import { Padding } from 'UI';

interface Props {
	children: React.ReactElement;
}

export const PaywallLayoutV3: FC<Props> = memo(props => {
	const { children } = props;
	const { isHideOptionPrices } = appStore.paywallStore.settings;
	const { safetyAssurance } = appStore.paymentStore.settings;

	return (
		<Padding bottom={20}>
			<div className='newFirstScreen2Wrapper'>
				<OneMinuteQuiz />
				{!isHideOptionPrices && children}
				{!isHideOptionPrices && <GetMyPlanBlock />}
				<MainScreen />
				<Plan />
				<SpecialFeatures />
				{!isHideOptionPrices && children}
				{safetyAssurance && <SafetyAssurance />}
				{!isHideOptionPrices && <GetMyPlanBlock />}
				<Reviews />
				<Featured />
				<Description />
			</div>
		</Padding>
	);
});
